module.exports = __webpack_public_path__ + "media/images/blank-2b1a51ea82032162a883fc4ba4651758.png";